import { Injectable, signal } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { BackendService, INaarGoNotificationUnsubscribeRequest, UserService } from 'nr-common';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	public hasGrantedPermission$ = signal<boolean>(false);

	readonly VAPID_PUBLIC_KEY = 'BFjekDGCCu51w0pOcfz7yVcuztjgsCMpuH9PgwzspjmXjsYbit7WjMJF1ljZEVzfA6KcAYWjMFvWVG_LVa17KI0';

	constructor(
		private swPush: SwPush,
		private backend: BackendService,
		private user: UserService,
	) { }

	public init() {
		//? Lasciare con il .then() per permettare al resto del codice di proseguire mentre si attende la risposta
		//? chrome://settings/content/notifications
		Notification.requestPermission()
			.then(p => {
				const hasGranted = p == 'granted';
				this.hasGrantedPermission$.set(hasGranted);
				if (hasGranted)
					this.subscribe();
				else
					this.unsubscribe();
			});
	}

	private async subscribe() {
		if (!this.swPush.isEnabled) {
			console.warn('Service Worker not enabled');
			return;
		}

		const subscription = await this.swPush.requestSubscription({
			serverPublicKey: this.VAPID_PUBLIC_KEY
		});
		
		const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
			let binary = '';
			const bytes = new Uint8Array(buffer);
			const len = bytes.byteLength;
			for (let i = 0; i < len; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			return btoa(binary);
		}
		//! Non dichiarare il tipo di request, perché non usa correttamente l'interfaccia ma la classe implementante. Funziona uguale
		const request = {
			userId: this.user.currentUser.id,
			subscription: {
				endpoint: subscription.endpoint,
				auth: arrayBufferToBase64(subscription.getKey('auth')!),
				p256DH: arrayBufferToBase64(subscription.getKey('p256dh')!)
			},
			uniqueID: null,
		}
		await this.backend.post('notification/subscribe', request);
	}

	private async unsubscribe() {
		const request: INaarGoNotificationUnsubscribeRequest = {
			userId: this.user.currentUser.id,
		}
		await this.backend.post('notification/unsubscribe', request);
	}
}
